/**
 * Kapitoly ukazky pod animaciou -- aktualna svieti, klik skoci na jej zaciatok.
 * `kapitoly`: [{ nazov, krok }] v poradi, ako idu v pribehu; `po` a `skocNa`
 * su z useScenar.
 */
function Kapitoly({ kapitoly, po, skocNa }) {
  const aktivna = kapitoly.reduce((posledna, k, i) => (po(k.krok) ? i : posledna), 0);

  return (
    <ol className="ukazky__kapitoly">
      {kapitoly.map((k, i) => (
        <li key={k.krok}>
          <button
            type="button"
            className={[
              "ukazky__kapitola",
              i === aktivna ? "ukazky__kapitola--aktivna" : "",
              i < aktivna ? "ukazky__kapitola--hotova" : "",
            ].join(" ")}
            aria-current={i === aktivna ? "step" : undefined}
            onClick={() => skocNa(k.krok)}
          >
            <span className="ukazky__kapitola-cislo">{i + 1}</span>
            {k.nazov}
          </button>
        </li>
      ))}
    </ol>
  );
}

export default Kapitoly;
